package com.kinoshazam.di

import com.kinoshazam.data.GlobalStateRepository
import org.koin.core.qualifier.named
import org.koin.dsl.module

fun commonStateModule() = module {
    single {
        GlobalStateRepository(
            secureStorage = get(named(STORAGE_SECURE)),
            commonStorage = get(named(STORAGE_COMMON)),
        )
    }
}
